/**
 * Created by lency on 9/17/16.
 */
class OriginalArticleController {
    constructor($scope, $stateParams, $sce,$filter, QueryAPI, clipboard, badge,ArticleAPI,CollectionAPI,
                AppConfig, modal, $state, message,$window, $timeout, pageTitle, userInfo, $transitions,Jurisdiction) {
        "ngInject";
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.Jurisdiction = Jurisdiction;
        this.$sce = $sce;
        this.QueryAPI = QueryAPI;
        this.badge = badge;
        this.AppConfig = AppConfig;
        this.message = message;
        this.$timeout = $timeout;
        this.modal = modal;
        this.clipboard = clipboard;
        this.pageTitle = pageTitle;
        this.userInfo = userInfo;
        this.loading = true;
        this.ArticleAPI = ArticleAPI;
        this.CollectionAPI=CollectionAPI;
        this.collectionActive=false;
        this.collection_loading = false;
        this.tranlsteFilter=$filter('translate');
        this.$window=$window;
        this.userInfo.setUser(this.appUser);
        this.list = [];
        this.articleId = null;
        let self = this;
        $transitions.onSuccess({
            to: (state) => {
                return state.name == 'app.page.original.article' || state.name == 'app.page.original.articleHash' || state.name == 'app.page.original.articleReproduction';
            }
        }, () => {
            self.init();
        });

        this.removeDialog={
            text:this.tranlsteFilter('page-original-text035'),
            sure:()=> {
                this.deleteArticle(this.removeDialog.original)
            },
            show:(original,event) => {
                event.stopPropagation();
                this.removeDialog.original=original;
                this.removeDialog.text=this.tranlsteFilter('page-original-text036')+original.title+'" ?';
                this.removeDialog.isActive=true;
            }
        }

        this.init();





    }


    init() {

        this.articleReproduction = null;
        this.showReproductionDetail = false;

        this.$scope.article = null;
        this.$scope.articleContentHtml = '';
        this.$scope.copyAuthorized = false;

        this.setShowReproductionDetail({'show': false});
        this.setReproduction({'reproduction': null});

        if (this.article) {
            this.loadArticle(this.article);
        } else {

            let api = null;
            if (this.$stateParams.id) {
                const from = this.$stateParams.from
                api = this.QueryAPI.one().get({...{'id': this.$stateParams.id, 'type': 'article'}, ...(from ? {from}:{})});
            } else if (this.$stateParams.hash) {
                api = this.QueryAPI.one('hash').get({'hash': this.$stateParams.hash, 'type': 'article'});
            } else if (this.$stateParams.reproduction) {
                api = this.QueryAPI.one('reproduction').get({'id': this.$stateParams.reproduction, 'type': 'article'});
            } else {
                self.setError({'error': true});
                return;
            }

            let self = this;

            api.then(
                function (article) {
                  self.articleId = article.id
                    self.loadArticle(article);
                    if(self.userInfo.user.email&&article.user_id==self.userInfo.user.id){
                       self.getList();//文章关联
                    }
                },
                function () {
                    self.loading = false;
                    self.setError({'error': true});
                }
            );

        }
    }


    loadArticle(article) {
        let self = this;

        self.$scope.article = article;

        self.$scope.publicKeyHtml = self.$sce.trustAsHtml(self.$scope.article.public_key.replace(/\n/g, "<br/>"));

        self.pageTitle.setTitle(article.title + ' ' + article.author_name);
        if (article.reproduction) {
            // Comes from reproduction url
            // Display reproduction
            article.reproduction.author_name=article.author_name;
            article.reproduction.license=article.license;
            article.reproduction.chain_server_url = article.chain_server_url;
            self.articleReproduction = article.reproduction;
            self.$scope.articleContentHtml = self.$sce.trustAsHtml(self.$scope.article.content + self.badge.getReproductionBadgeContent(article, article.reproduction));

            self.setReproduction({'reproduction': article.reproduction});
            self.showReproductionDetail = true;
            self.setShowReproductionDetail({'show': true});
            self.loading = false;
            self.pageLoaded();
        } else {
            self.$scope.articleContentHtml = self.$sce.trustAsHtml(self.$scope.article.content + self.badge.getBadgeContent(article));
            self.loadReproduction();
        }
        //获取用户是否已经收藏
        if(!this.userInfo.isGuest()){
            this.collectionInfo(article)
        }
    }

    loadReproduction() {
        if (!this.userInfo.isGuest()) {
            if (this.$scope.article.license.type) {
                let self = this;
                this.QueryAPI.one().one('article', this.$scope.article.id).one('reproduction').get().then(
                    (reproduction) => {

                        if (reproduction && reproduction.id) {
                            self.setReproduction({'reproduction': reproduction});
                            self.showReproductionDetail = false;
                            self.setShowReproductionDetail({'show': false});
                            self.articleReproduction = reproduction;
                        }
                        self.pageLoaded();
                    },
                    (response) => {
                        self.message.error(response.data);
                        self.pageLoaded();
                    }
                );
            } else {
                this.pageLoaded();
            }

        } else {
            this.pageLoaded();
        }
    }

    pageLoaded() {

        this.loading = false;

        if(this.$scope.article.locked || this.$scope.article.user.locked) {
            this.message.error(this.tranlsteFilter('page-original-text037'), 0);
        }

        if(this.userInfo.isOriginalOwner(this.$scope.article, this.articleReproduction))
        {
            this.$scope.copyAuthorized = true;
        }
    }

    get() {
        this.$scope.copyAuthorized = true;
        this.copy();
    }

    copy() {
        this.clipboard.copyElementById('article-content');
    }

    showWeixinShare() {
        let url = this.AppConfig.server_url + '/original/qrcode?type=article&id=' + this.$scope.article.id;
        this.shareToWeixin({url: url});
    }
    deleteArticle(article){

        let self = this;

        self.loading = true;

        this.ArticleAPI.one(article.id).remove().then(
            (res) => {
                if(res.status.code==200){
                    self.appUser.article_count--;
                    self.message.success(self.tranlsteFilter('page-original-text038'));
                    self.$state.go('app.page.author',{id: article.uuid});
                }else if(res.status.code==422){
                    if(res.status.message=='Authorized'){
                        self.message.error(self.tranlsteFilter('page-original-text039'));
                    }else{
                        self.message.error(self.tranlsteFilter('page-original-text040'));
                    }
                }
                self.loading = false;

            },
            (response) => {
                self.loading = false;
                self.message.error(response.data);
            }
        );
    }
    //获取收藏属性
    collectionInfo(article){
        let self = this;
        this.CollectionAPI.one().get({'resource_type_id': 1, 'resource_id': article.id}).then(
            function (res) {
                self.collectionActive=res.data.active;
            },
            function () {
                // self.loading = false;
                // self.setError({'error': true});
            }
        );
    }
    collection(article){
        if(this.userInfo.isGuest()){
            this.$state.go('app.face.index.user.form.login');
            return;
        }
        let self = this;
        self.collection_loading = true;
        let api=this.CollectionAPI;
         if(self.collectionActive){
             api.one().remove({resource_type_id: 1, resource_id: article.id}).then(
                 () => {
                     self.collection_loading = false;
                     self.message.success(self.tranlsteFilter('page-original-text041'));
                     self.collectionActive=false
                 },
                 (response) => {
                     self.collection_loading = false;
                     self.message.error(response.data);
                 }
             );
         }else{
             api.post({resource_type_id: 1, resource_id: article.id}).then(
                 () => {
                     self.collection_loading = false;
                     self.message.success(self.tranlsteFilter('page-original-text042'));
                     self.collectionActive=true
                 },
                 (response) => {
                     self.collection_loading = false;
                     self.message.error(response.data);
                 }
             );
         }

    }
    collection_text(){
        let self = this;
        if(self.collection_loading){
            return this.tranlsteFilter('page-original-text043')
        }else{
            if(self.collectionActive){
                return this.tranlsteFilter('page-original-text044')
            }else{
                return this.tranlsteFilter('page-original-text045')
            }
        }
    }

    getList(){
      this.ArticleAPI.one(this.articleId+"/sensitive").get({count:10}).then(res=>{
         this.list = res.data
      },err=>{
         console.log(err)
      })
    }


    checkEditor(){
      this.permission = JSON.parse(window.localStorage.getItem("loginUser"))

      let param = Object.assign(this.permission);
      return this.Jurisdiction.checkStatusShow(param);
   }
}

export default OriginalArticleController;



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-article/original-article.controller.js